/**
 * Sistema de Permisos - Estructura Completa
 * Cada permiso está estructurado como: módulo.submódulo.funcionalidad.acción
 */

export const PERMISSIONS_STRUCTURE = {
  agricultura: {
    label: "🌾 Agricultura",
    children: {
      rrhh_dashboard: {
        label: "Dashboard RRHH",
        permissions: [
          { id: "agricultura.rrhh.dashboard.view", label: "Ver Dashboard" },
          { id: "agricultura.rrhh.dashboard.stats", label: "Ver Estadísticas Generales" },
        ]
      },
      trabajadores: {
        label: "Gestión de Trabajadores",
        permissions: [
          { id: "agricultura.rrhh.trabajadores.view", label: "Ver Lista de Trabajadores" },
          { id: "agricultura.rrhh.trabajadores.create", label: "Registrar Nuevos Trabajadores" },
          { id: "agricultura.rrhh.trabajadores.edit", label: "Editar Información" },
          { id: "agricultura.rrhh.trabajadores.delete", label: "Eliminar Trabajadores" },
          { id: "agricultura.rrhh.trabajadores.change_status", label: "Cambiar Status" },
        ]
      },
      expedientes: {
        label: "Expedientes",
        permissions: [
          { id: "agricultura.rrhh.expediente.view", label: "Ver Expedientes Completos" },
          { id: "agricultura.rrhh.expediente.edit", label: "Editar Expedientes" },
          { id: "agricultura.rrhh.expediente.documents", label: "Gestionar Documentos" },
          { id: "agricultura.rrhh.expediente.history", label: "Ver Historial de Cambios" },
        ]
      },
      asistencia: {
        label: "Control de Asistencia",
        permissions: [
          { id: "agricultura.rrhh.asistencia.view", label: "Ver Asistencia" },
          { id: "agricultura.rrhh.asistencia.create", label: "Registrar Asistencia" },
          { id: "agricultura.rrhh.asistencia.edit", label: "Editar Registros" },
          { id: "agricultura.rrhh.asistencia.export", label: "Exportar Reportes" },
        ]
      },
      disciplinario: {
        label: "Historial Disciplinario",
        permissions: [
          { id: "agricultura.rrhh.disciplinario.view", label: "Ver Historial" },
          { id: "agricultura.rrhh.disciplinario.create", label: "Registrar Incidentes" },
          { id: "agricultura.rrhh.disciplinario.edit", label: "Editar Incidentes" },
          { id: "agricultura.rrhh.disciplinario.delete", label: "Eliminar Incidentes" },
        ]
      },
      produccion_dashboard: {
        label: "Dashboard de Producción",
        permissions: [
          { id: "agricultura.produccion.dashboard.view", label: "Ver Dashboard" },
          { id: "agricultura.produccion.dashboard.stats", label: "Ver Estadísticas" },
        ]
      },
      hoja_pesador: {
        label: "Hoja del Pesador",
        permissions: [
          { id: "agricultura.produccion.hoja_pesador.view", label: "Ver Hoja del Pesador" },
          { id: "agricultura.produccion.hoja_pesador.create", label: "Crear Entregas" },
          { id: "agricultura.produccion.hoja_pesador.edit", label: "Editar Entregas" },
          { id: "agricultura.produccion.hoja_pesador.delete", label: "Eliminar Entregas" },
          { id: "agricultura.produccion.hoja_pesador.export", label: "Exportar PDF" },
          { id: "agricultura.produccion.hoja_pesador.manage_inspectors", label: "Gestionar Inspectores" },
          { id: "agricultura.produccion.hoja_pesador.manage_drivers", label: "Gestionar Conductores" },
        ]
      },
      lotes_parcelas: {
        label: "Lotes y Parcelas",
        permissions: [
          { id: "agricultura.produccion.lotes.view", label: "Ver Lotes" },
          { id: "agricultura.produccion.lotes.create", label: "Crear Lotes" },
          { id: "agricultura.produccion.lotes.edit", label: "Editar Lotes" },
          { id: "agricultura.produccion.lotes.delete", label: "Eliminar Lotes" },
          { id: "agricultura.produccion.parcelas.view", label: "Ver Parcelas" },
          { id: "agricultura.produccion.parcelas.create", label: "Crear Parcelas" },
          { id: "agricultura.produccion.parcelas.edit", label: "Editar Parcelas" },
          { id: "agricultura.produccion.parcelas.delete", label: "Eliminar Parcelas" },
        ]
      },
      registros_produccion: {
        label: "Registros de Producción",
        permissions: [
          { id: "agricultura.produccion.registros.view", label: "Ver Registros" },
          { id: "agricultura.produccion.registros.create", label: "Crear Registros" },
          { id: "agricultura.produccion.registros.edit", label: "Editar Registros" },
          { id: "agricultura.produccion.registros.delete", label: "Eliminar Registros" },
        ]
      },
      reportes_produccion: {
        label: "Reportes de Producción",
        permissions: [
          { id: "agricultura.produccion.reportes.view", label: "Ver Reportes" },
          { id: "agricultura.produccion.reportes.create", label: "Generar Reportes Personalizados" },
          { id: "agricultura.produccion.reportes.export", label: "Exportar Reportes" },
        ]
      },
      salud_seguridad: {
        label: "Salud y Seguridad",
        permissions: [
          { id: "agricultura.produccion.salud_seguridad.view", label: "Ver Incidentes" },
          { id: "agricultura.produccion.salud_seguridad.create", label: "Registrar Incidentes" },
          { id: "agricultura.produccion.salud_seguridad.edit", label: "Editar Incidentes" },
          { id: "agricultura.produccion.salud_seguridad.manage_epp", label: "Gestionar EPP" },
        ]
      },
      cronograma_cosecha: {
        label: "Cronograma de Cosecha",
        permissions: [
          { id: "agricultura.produccion.cronograma.view", label: "Ver Cronograma" },
          { id: "agricultura.produccion.cronograma.create", label: "Crear Eventos" },
          { id: "agricultura.produccion.cronograma.edit", label: "Editar Cronograma" },
          { id: "agricultura.produccion.cronograma.delete", label: "Eliminar Eventos" },
          { id: "agricultura.produccion.cronograma.assign", label: "Asignar Trabajadores" },
        ]
      },
      mantenimiento_produccion: {
        label: "Mantenimiento (Producción)",
        permissions: [
          { id: "agricultura.produccion.mantenimiento.view", label: "Ver Mantenimiento" },
          { id: "agricultura.produccion.mantenimiento.create", label: "Crear Registros" },
          { id: "agricultura.produccion.mantenimiento.edit", label: "Editar Registros" },
          { id: "agricultura.produccion.mantenimiento.delete", label: "Eliminar Registros" },
          { id: "agricultura.produccion.mantenimiento.picudos", label: "Registro de Picudos" },
        ]
      },
      inventario_maquinaria: {
        label: "Inventario de Maquinaria",
        permissions: [
          { id: "agricultura.maquinaria.inventario.view", label: "Ver Inventario" },
          { id: "agricultura.maquinaria.inventario.create", label: "Registrar Maquinaria" },
          { id: "agricultura.maquinaria.inventario.edit", label: "Editar Información" },
          { id: "agricultura.maquinaria.inventario.delete", label: "Eliminar Maquinaria" },
          { id: "agricultura.maquinaria.inventario.documents", label: "Gestionar Documentos" },
        ]
      },
      inspecciones_maquinaria: {
        label: "Inspecciones",
        permissions: [
          { id: "agricultura.maquinaria.inspecciones.view", label: "Ver Inspecciones" },
          { id: "agricultura.maquinaria.inspecciones.create", label: "Registrar Inspecciones" },
          { id: "agricultura.maquinaria.inspecciones.edit", label: "Editar Inspecciones" },
          { id: "agricultura.maquinaria.inspecciones.delete", label: "Eliminar Inspecciones" },
        ]
      },
      uso_maquinaria: {
        label: "Registro de Uso",
        permissions: [
          { id: "agricultura.maquinaria.uso.view", label: "Ver Historial de Uso" },
          { id: "agricultura.maquinaria.uso.create", label: "Registrar Uso" },
          { id: "agricultura.maquinaria.uso.edit", label: "Editar Registros" },
          { id: "agricultura.maquinaria.uso.assign", label: "Asignar Operadores" },
        ]
      },
      mantenimiento_maquinaria: {
        label: "Mantenimiento",
        permissions: [
          { id: "agricultura.maquinaria.mantenimiento.view", label: "Ver Historial" },
          { id: "agricultura.maquinaria.mantenimiento.create", label: "Programar Mantenimiento" },
          { id: "agricultura.maquinaria.mantenimiento.edit", label: "Editar Programación" },
          { id: "agricultura.maquinaria.mantenimiento.alerts", label: "Ver Alertas" },
        ]
      },
      empresas_fincas: {
        label: "Empresas y Fincas",
        permissions: [
          { id: "agricultura.admin.empresas.view", label: "Ver Empresas" },
          { id: "agricultura.admin.empresas.create", label: "Crear Empresas" },
          { id: "agricultura.admin.empresas.edit", label: "Editar Empresas" },
          { id: "agricultura.admin.empresas.delete", label: "Eliminar Empresas" },
          { id: "agricultura.admin.fincas.view", label: "Ver Fincas" },
          { id: "agricultura.admin.fincas.create", label: "Crear Fincas" },
          { id: "agricultura.admin.fincas.edit", label: "Editar Fincas" },
          { id: "agricultura.admin.fincas.delete", label: "Eliminar Fincas" },
        ]
      },
      usuarios_sistema: {
        label: "Usuarios del Sistema",
        permissions: [
          { id: "agricultura.admin.usuarios.view", label: "Ver Usuarios" },
          { id: "agricultura.admin.usuarios.create", label: "Crear Usuarios" },
          { id: "agricultura.admin.usuarios.edit", label: "Editar Usuarios" },
          { id: "agricultura.admin.usuarios.delete", label: "Eliminar Usuarios" },
          { id: "agricultura.admin.usuarios.permissions", label: "Gestionar Permisos" },
        ]
      },
      auditoria: {
        label: "Auditoría y Historial",
        permissions: [
          { id: "agricultura.admin.historial.view", label: "Ver Historial de Cambios" },
          { id: "agricultura.admin.historial.export", label: "Exportar Logs" },
          { id: "agricultura.admin.historial.filter", label: "Filtrar por Usuario/Módulo" },
        ]
      },
      tablero_tareas: {
        label: "Tablero de Tareas",
        permissions: [
          { id: "agricultura.admin.tareas.view", label: "Ver Tablero" },
          { id: "agricultura.admin.tareas.create", label: "Crear Tareas" },
          { id: "agricultura.admin.tareas.edit", label: "Editar Tareas" },
          { id: "agricultura.admin.tareas.delete", label: "Eliminar Tareas" },
          { id: "agricultura.admin.tareas.assign", label: "Asignar Tareas" },
          { id: "agricultura.admin.tareas.comments", label: "Agregar Comentarios" },
        ]
      },
      notificaciones: {
        label: "Notificaciones",
        permissions: [
          { id: "agricultura.admin.notificaciones.view", label: "Ver Bandeja de Entrada" },
          { id: "agricultura.admin.notificaciones.manage", label: "Gestionar Notificaciones" },
        ]
      }
    }
  },
  ganaderia: {
    label: "🐄 Ganadería",
    children: {
      ganaderia_dashboard: {
        label: "Dashboard de Ganadería",
        permissions: [
          { id: "ganaderia.dashboard.view", label: "Ver Dashboard" },
          { id: "ganaderia.dashboard.stats", label: "Ver Estadísticas del Hato" },
        ]
      },
      inventario_ganado: {
        label: "Inventario de Animales",
        permissions: [
          { id: "ganaderia.inventario.animales.view", label: "Ver Inventario" },
          { id: "ganaderia.inventario.animales.create", label: "Registrar Animales" },
          { id: "ganaderia.inventario.animales.edit", label: "Editar Información" },
          { id: "ganaderia.inventario.animales.delete", label: "Eliminar Animales" },
          { id: "ganaderia.inventario.detalle.view", label: "Ver Detalle Completo" },
          { id: "ganaderia.inventario.filters", label: "Usar Filtros Avanzados" },
        ]
      },
      registro_ganado: {
        label: "Registro de Ganado",
        permissions: [
          { id: "ganaderia.registro.create", label: "Registrar Nuevos Animales" },
          { id: "ganaderia.registro.purchase_info", label: "Registrar Información de Compra" },
          { id: "ganaderia.registro.registry", label: "Gestionar Registros" },
        ]
      },
      peso_ganado: {
        label: "Gestión de Peso",
        permissions: [
          { id: "ganaderia.peso.registros.view", label: "Ver Registros de Peso" },
          { id: "ganaderia.peso.registros.create", label: "Registrar Pesos" },
          { id: "ganaderia.peso.historial.view", label: "Ver Historial" },
          { id: "ganaderia.peso.graficas.view", label: "Ver Gráficas de Evolución" },
          { id: "ganaderia.peso.comparar", label: "Comparar entre Animales" },
        ]
      },
      salud_tratamientos: {
        label: "Salud - Tratamientos",
        permissions: [
          { id: "ganaderia.salud.tratamientos.view", label: "Ver Tratamientos" },
          { id: "ganaderia.salud.tratamientos.create", label: "Registrar Tratamientos" },
          { id: "ganaderia.salud.tratamientos.edit", label: "Editar Tratamientos" },
          { id: "ganaderia.salud.tratamientos.upcoming", label: "Ver Tratamientos Próximos" },
        ]
      },
      salud_diagnosticos: {
        label: "Salud - Diagnósticos",
        permissions: [
          { id: "ganaderia.salud.diagnosticos.view", label: "Ver Diagnósticos" },
          { id: "ganaderia.salud.diagnosticos.create", label: "Registrar Diagnósticos" },
          { id: "ganaderia.salud.diagnosticos.edit", label: "Editar Diagnósticos" },
        ]
      },
      salud_recursos: {
        label: "Recursos Veterinarios",
        permissions: [
          { id: "ganaderia.salud.productos.view", label: "Ver Productos Veterinarios" },
          { id: "ganaderia.salud.productos.manage", label: "Gestionar Productos" },
          { id: "ganaderia.salud.veterinarios.view", label: "Ver Veterinarios" },
          { id: "ganaderia.salud.veterinarios.manage", label: "Gestionar Veterinarios" },
        ]
      },
      reproduccion_embarazos: {
        label: "Reproducción - Embarazos",
        permissions: [
          { id: "ganaderia.reproduccion.embarazos.view", label: "Ver Embarazos" },
          { id: "ganaderia.reproduccion.embarazos.create", label: "Registrar Embarazos" },
          { id: "ganaderia.reproduccion.embarazos.edit", label: "Actualizar Estado" },
          { id: "ganaderia.reproduccion.embarazos.delete", label: "Eliminar Embarazos" },
        ]
      },
      reproduccion_seguimiento: {
        label: "Reproducción - Seguimiento",
        permissions: [
          { id: "ganaderia.reproduccion.revisiones.view", label: "Ver Revisiones" },
          { id: "ganaderia.reproduccion.revisiones.create", label: "Registrar Revisiones" },
          { id: "ganaderia.reproduccion.palpaciones.view", label: "Ver Palpaciones" },
          { id: "ganaderia.reproduccion.palpaciones.create", label: "Registrar Palpaciones" },
        ]
      },
      reproduccion_partos: {
        label: "Reproducción - Partos",
        permissions: [
          { id: "ganaderia.reproduccion.partos.view", label: "Ver Partos" },
          { id: "ganaderia.reproduccion.partos.create", label: "Registrar Partos" },
          { id: "ganaderia.reproduccion.abortos.create", label: "Registrar Abortos" },
        ]
      },
      genealogia: {
        label: "Genealogía",
        permissions: [
          { id: "ganaderia.reproduccion.genealogia.view", label: "Ver Genealogía" },
          { id: "ganaderia.reproduccion.genealogia.edit", label: "Vincular Padres/Madres" },
          { id: "ganaderia.reproduccion.genealogia.link_offspring", label: "Vincular Crías" },
          { id: "ganaderia.reproduccion.genealogia.tree", label: "Ver Árbol Genealógico" },
        ]
      }
    }
  }
};

/**
 * Obtener lista plana de todos los permisos
 */
export const getAllPermissions = () => {
  const permissions = [];
  
  Object.entries(PERMISSIONS_STRUCTURE).forEach(([moduleKey, module]) => {
    Object.entries(module.children).forEach(([submoduleKey, submodule]) => {
      permissions.push(...submodule.permissions);
    });
  });
  
  return permissions;
};

/**
 * Verificar si un usuario tiene un permiso específico
 */
export const hasPermission = (userPermissions, requiredPermission) => {
  if (!userPermissions || !Array.isArray(userPermissions)) return false;
  if (!requiredPermission) return true; // Si no se requiere permiso, permitir acceso
  
  // Si es admin, tiene todos los permisos
  if (userPermissions.includes('*')) return true;
  
  // Verificar permiso exacto
  if (userPermissions.includes(requiredPermission)) return true;
  
  // Verificar permisos con comodín (ej: agricultura.* da acceso a agricultura.rrhh.dashboard.view)
  return userPermissions.some(permission => {
    if (permission.endsWith('.*')) {
      const basePermission = permission.slice(0, -2);
      return requiredPermission.startsWith(basePermission);
    }
    return false;
  });
};

/**
 * Verificar si un usuario tiene alguno de los permisos requeridos
 */
export const hasAnyPermission = (userPermissions, requiredPermissions) => {
  if (!Array.isArray(requiredPermissions)) return hasPermission(userPermissions, requiredPermissions);
  return requiredPermissions.some(perm => hasPermission(userPermissions, perm));
};
